import React, { PureComponent } from 'react'
import { string, shape, func } from 'prop-types'

import Input from '@active/react-ui/Input'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Form, { FormConsumer } from '@active/react-ui/Form'
import Popover from '@active/react-ui/Popover'
import { Locale } from '@active/react-utils/i18n'
import noop from 'lodash/noop'
import handleKeyUp from '../../../utils/numberHandler'
import { validateBIC, validateIBAN } from '../../../utils/validators'
import './EUDDFields.scss'

const bicValidatorBuilder = (value, subscribeValue) => {
  if (!validateBIC(value)
  || (subscribeValue.iban.value && subscribeValue.iban.value.substring(0, 2) !== value.substring(4, 6))) {
    return 'passport.lib.components.payment.eudd.valid.bic'
  }
  return undefined
}

const ibanValidatorBuilder = (value, subscribeValue) => {
  if (!validateIBAN(value)
  || (subscribeValue.bicCode.value && value.substring(0, 2) !== subscribeValue.bicCode.value.substring(4, 6))) {
    return 'passport.lib.components.payment.eudd.valid.iban'
  }
  return undefined
}
class EUDDFields extends PureComponent {
  static propTypes = {
    fields: shape({
      accountName: string,
      bicCode: string,
      iban: string,
    }).isRequired,
    name: string.isRequired,
    fieldsChangeCallBack: func.isRequired,
    submitFieldsTrigger: func.isRequired,
  }

  submitFormTrigger = noop

  componentDidMount() {
    const { submitFieldsTrigger } = this.props
    submitFieldsTrigger(this.submitFormTrigger)
  }

  handleSubmit = values => {
    const { fieldsChangeCallBack } = this.props
    fieldsChangeCallBack(values)
  }

  render() {
    const { fields, name } = this.props
    const bicHint = Locale({ id: 'passport.lib.components.payment.eudd.bic.hint' })
    const ibanHint = Locale({ id: 'passport.lib.components.payment.eudd.iban.hint' })

    return (
      <div className="checkout__eudd-fields">
        <Form
          name={name}
          horizontal
          initialValues={fields}
          onSubmit={this.handleSubmit}
        >
          <FormGroup required>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.name" /></FormLabel>
            <FormField
              name="accountName"
              min={0}
              maxLength={50}
              as={Input}
            />
          </FormGroup>
          <FormGroup required>
            <FormLabel><Locale id="passport.lib.components.payment.eudd.bic" /></FormLabel>
            <FormField
              name="bicCode"
              onKeyUp={handleKeyUp}
              subscribe={['iban']}
              validate={bicValidatorBuilder}
              as={Input}
            />
            <Popover content={bicHint} style={{ zIndex: 10 }} placement="top-start" theme="dark">
              <i className="ic-question-r" />
            </Popover>
          </FormGroup>
          <FormGroup required>
            <FormLabel><Locale id="passport.lib.components.payment.eudd.iban" /></FormLabel>
            <FormField
              name="iban"
              onKeyUp={handleKeyUp}
              subscribe={['bicCode']}
              validate={ibanValidatorBuilder}
              as={Input}
            />
            <Popover content={ibanHint} style={{ zIndex: 10 }} placement="top-start" theme="dark">
              <i className="ic-question-r" />
            </Popover>
          </FormGroup>
          <FormConsumer>
            {({ form }) => {
              this.submitFormTrigger = form.submitForm
              return null
            }}
          </FormConsumer>
        </Form>
      </div>
    )
  }
}

export default EUDDFields
